import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HarpApplicationRoutes from "../../HarpApplication/Router/routes";
import { withTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import styles from "./Router.module.scss";
import FadeLoader from "react-spinners/FadeLoader";
import { authenticateActions } from "../../../redux/authenticateActions";
import { addToGoogleDataLayer } from "../../../shared/const/utls";

const Router = ({ t, i18n }) => {
  const isLoading = useSelector((state) => state.metaData.metaData.isLoading);
  const override = {
    left: "46%",
    top: "25%",
    position: "fixed",
    zIndex: 9999
  };

  // const authenticate = useSelector(state => state.authenticate);
  const dispatch = useDispatch();

  const location = useLocation();

  let locationTag = "";

  if (location.pathname === "/en/not-eligible") {
  }

  useEffect(() => {
    try {
      const locationValue = locationTag
        ? `${location.pathname}${locationTag}`
        : location.pathname;
      addToGoogleDataLayer(locationValue, "HARP", "en");
      window.scrollTo(0, 0);
    } catch (e) {
      console.log(e);
    }
  }, [location.pathname, locationTag]);

  // Get authentication info
  useEffect(() => {
    dispatch(authenticateActions.retrieve());
  }, [dispatch]);
  const { questionDataList } = useSelector((state) => state.app);
  const { personalInformation } = useSelector((state) => state.app);
  const appData = useSelector((state) => state.app);

  return (
    <React.Fragment>
      <div className={isLoading ? styles["loading"] : ""}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh"
          }}
        >
          <Translation i18n={i18n} t={t} />
        </div>
      </div>
      <FadeLoader
        cssOverride={override}
        height={25}
        width={8}
        radius={2}
        margin={50}
        color={"#0358A4"}
        loading={isLoading}
      />
    </React.Fragment>
  );
};

const Translation = ({ t, i18n }) => {
  const location = useLocation();

  useEffect(() => {
    try {
      if (location.pathname.includes("/fr") && i18n.language !== "fr") {
        i18n.changeLanguage("fr");
        document.getElementById("ApplicationTitle").innerHTML = t("title");
        document.getElementById("AppLanguage").lang = i18n.language;
      } else if (location.pathname.includes("/en") && i18n.language !== "en") {
        i18n.changeLanguage("en");
        document.getElementById("ApplicationTitle").innerHTML = t("title");
        document.getElementById("AppLanguage").lang = i18n.language;
      }
    } catch (e) {
      console.log(e);
    }
  }, [location.pathname, i18n, t]);

  return <HarpApplicationRoutes />;
};

export default withTranslation("common")(Router);
